// hooks/useLeagueDetails.js
import { useQuery } from "react-query";
import axios from "axios";
import { useAuth0 } from "@auth0/auth0-react";

const getLeagueDetails = async (leagueId, getAccessTokenSilently) => {
  const apiUrl = process.env.REACT_APP_API_URL;
  const token = await getAccessTokenSilently();

  const { data } = await axios.get(`${apiUrl}/api/league/${leagueId}`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  return data;
};

export const useLeagueDetails = (leagueId) => {
  const { getAccessTokenSilently } = useAuth0();

  return useQuery(
    ["leagueDetails", leagueId],
    () => getLeagueDetails(leagueId, getAccessTokenSilently),
    {
      // The query will not execute until the leagueId is available
      enabled: !!leagueId,
    }
  );
};
